var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRejectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 59.9995,
    rx: 29.9998,
    fill: "#FF6F66"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.1988 29.9999L41.5439 20.6545C42.1521 20.0466 42.1521 19.0638 41.5439 18.4559C40.936 17.848 39.9532 17.848 39.3453 18.4559L29.9999 27.8013L20.6547 18.4559C20.0466 17.848 19.064 17.848 18.4561 18.4559C17.848 19.0638 17.848 20.0466 18.4561 20.6545L27.8012 29.9999L18.4561 39.3453C17.848 39.9532 17.848 40.9361 18.4561 41.544C18.7591 41.8472 19.1574 41.9995 19.5554 41.9995C19.9535 41.9995 20.3515 41.8472 20.6547 41.544L29.9999 32.1986L39.3453 41.544C39.6485 41.8472 40.0465 41.9995 40.4446 41.9995C40.8426 41.9995 41.2407 41.8472 41.5439 41.544C42.1521 40.9361 42.1521 39.9532 41.5439 39.3453L32.1988 29.9999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectIcon);
export default __webpack_public_path__ + "static/media/rejectIcon.28a426c494d74180c55927576f68742c.svg";
export { ForwardRef as ReactComponent };